import { useTranslation } from "react-i18next";
import {DownOutlined, PlusOutlined, SearchOutlined, UpOutlined} from '@ant-design/icons';
import {Button, Col, Row, Typography} from 'antd';
import React, {ChangeEvent, KeyboardEvent} from 'react';
import FormInput from '../../../../form-input/FormInput';


type FilterTableProps = {
  showFilter?: boolean
  searchValue?: string
  handleChangeInput?: (e: ChangeEvent<HTMLInputElement>) => void
  handleSearch?: (e: KeyboardEvent<HTMLSpanElement>) => void
  handleSubmitSearch?: () => void
  handleOpenFilter?: () => void
  handleOpen?: () => void
};


const FilterFormTable = ({
                           showFilter,
                           handleOpenFilter,
                           searchValue,
                           handleChangeInput,
                           handleSearch,
                           handleSubmitSearch,
                           handleOpen
                         }: FilterTableProps) => {
  const { t } = useTranslation();
  return (
    <div className="history-table-style">
      <div className="heading-table">
        <Row gutter={[{md: 8, xl: 8, xs: 8}, 8]}>
          <Col>
            <div className="heading-table-filter">
              <Button className={`filter-button ${showFilter ? 'open' : ''}`} onClick={handleOpenFilter}>
                <Typography.Text className="filter-text">{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
                {showFilter ? <UpOutlined/> : <DownOutlined/>}
              </Button>
            </div>
          </Col>
          <Col>
            <div className="heading-table-search">
              <FormInput
                placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                value={searchValue}
                onChange={handleChangeInput}
                onKeyPress={handleSearch}
                afterPrefixIcon={
                  <SearchOutlined onClick={handleSubmitSearch}/>
                }
              />
            </div>
          </Col>
          <Col>
            <Button onClick={handleOpen} className="btn btn-primary">
              <PlusOutlined/>
              <Typography.Text>{t("Mở lớp ghi danh", "Mở lớp ghi danh")}</Typography.Text>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FilterFormTable;